export function checkPhone (num) {
  return (/^1\d{10}$/.test(num))
};

/**
 * 是否是正整数
 * @param str
 * @returns {boolean}
 */
export function isInteger (str) {
  str = str || ''
  if (/^\+?[1-9]\d*$/.test(str)) { // 为空，返回true
    return true
  } else {
    return false
  }
}
/**
 * 渠道方基础信息是否是整数
 * @param str
 * @returns {boolean}
 */
export function isBasicInteger (str) {
  if (/^\+?[0-9]\d*$/.test(str)) { // 为空，返回true
    return true
  } else {
    return false
  }
}

export function isEmpty (str) {
  str = str || ''
  if (/^\s*$/.test(str)) { // 为空，返回true
    return true
  } else {
    return false
  }
}

export function isNumber (str) { // 是数字 为true
  str = str || 0
  if (/^\d+(\.\d+)?$/.test(str)) {　
    return true
  } else {
    return false
  }
}
/**
 * 验证费率
 * @param str
 * @returns {boolean}
 */
export function isFeeCheck (str) {
  str = str || 0
  if (/^-?(0(\.\d*)?)$/.test(str)) {
    return true
  } else {
    return false
  }
}

export function isTel (str) { // 是电话号码 为true（数字和——）
  str = str || ''
  if (/^(((\d{3,4}-?)?\d{7,8})|(1\d{10}))$/.test(str)) {
    return true
  } else {
    return false
  }
}

export function isChina (str) {
  str = str.replace(/[\u4e00-\u9fa5]+/g, '')
  return str
}

export function filterEmoji (name) {
  let newName = '',
    is4Byte = function (str) {
      return str.codePointAt(0) > 65535
    }
  for (let item of name) {
    if (is4Byte(item)) {
      item = ''
    }
    newName += item
  }
  return newName
}

export function isSpecial (val) {
  val = val.trim() || ''
  // var regEn = /[`~!@#$%^¥&*()_+<>?"=|{}':;',.\/;'[\]·~！#￥%……&*（——）；|.<>/{}《》？”“'。，、【】[\]️ ♂️♀️]/im
  var reg = new RegExp("[`~!@#$^&*()=|{}:;,\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“。，、？]")
  if (reg.test(val)) {
    return false
  } else {
    return true
  }
}

export function isRate(val) {
  val = +val
  if(val > -0.99999999999 && val <1) {
    return true
  }else {
    return false
  }
}
/**
 * 小数点后最多6位
 * @param val
 * @returns {boolean}
 */
export function isFeePoint(val) {
  var reg = /^[+-]?\d+(\.\d{1,6})?$/
  if(reg.test(val)) {
    return true
  }else {
    return false
  }
}


export function checkLength (str, len) { // 超出了，返回true
  str = str.trim() || ''
  if (str.length > len) {
    return true
  } else {
    return false
  }
}

export function isEqual (str1, str2) { // 不相同，返回true
  str1 = str1 || ''
  str2 = str2 || ''
  if (str1 === str2) {
    return false
  } else {
    return true
  }
}

export function repeatStr (str, count) {
  var text = ''
  for (var i = 0; i < count; i++) {
    text += str
  }
  return text
}

export function replaceStr (str, regArr, type, ARepText) { // demo:replaceStr('18819322663',[3,5,3],0)
  var regtext = '',
    Reg = null,
    replaceText = ARepText || '*'
  if (regArr.length === 3 && type === 0) {
    regtext = '(\\w{' + regArr[0] + '})\\w{' + regArr[1] + '}(\\w{' + regArr[2] + '})'
    Reg = new RegExp(regtext)
    var replaceCount = repeatStr(replaceText, regArr[1])
    return str.replace(Reg, '$1' + replaceCount + '$2')
  }
}

export function checkPwd (str) {
  str = str || ''
  if (/^[a-zA-Z0-9]{6,16}$/.test(str)) {
    return false
  } else {
    return true
  }
}
/**
 * 风控判断单笔单日钱
 * @param str
 * @returns {boolean}
 */
export function  checkRuleMoney(str) {
  str = str || ''
  if (/^\d+(\.\d{0,2})?$/.test(str)){
    return false
  } else {
    return true
  }
}
export function checkPwd2 (str) {
  str = str || ''
  if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(str)) {
    return false
  } else {
    return true
  }
}

export function checkArrLen (arr) {
  arr = arr || []
  if (arr.length < 1) { return false } else { return true }
}

/**
 * 过滤emoji表情、只允许输入中英文，中英文标点，阿拉伯数字、空格、换行
 * @param str
 * @returns {string}
 */
export function filterSpecial (str) {
  str = filterEmoji(str) || ''
  let reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\·\~\！\@\#\¥\%\……\&\*\（\）\——\-\+\=\【\】\{\}\、\|\；\‘\’\：\“\”\《\》\？\，\。\、\`\~\!\#\$\%\^\&\*\(\)\_\[\]{\}\\\|\;\'\'\:\"\"\,\.\/\<\>\?\/\s\$]/g
  return str.replace(reg, '')
}

/**
 * 金额校验，0.01 - 100000
 * @param str
 * @returns {string}
 */
export function validatePrice (str) {
  let reg = /^[1-9]\d{0,4}(\.\d{0,2})?$|^0(\.\d{0,2})?$|^100000$/
  return reg.test(str)
}
